import image from './Image';
import video from './Video';
import defaultRenderer from './Default';
import autoplayContent from './AutoPlayContent';

export const renderers = [image, video, autoplayContent, defaultRenderer];
